import { ProfessionIcon } from './profession-icon';

export const IconMechanic = () => (
  <ProfessionIcon bg="#FFF3E0">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke="#FF9800" strokeWidth="1.8" />
      <path
        d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"
        stroke="#FF9800"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
